$(document).ready(function () {
    initStorageForm();
});

function initStorageForm() {
    let form = $('.storage-create-form');
    if (form.length === 0) {
        return null;
    }

    form
        .on('change', '#id_device_uid', function () {
            $(this).closest('form').submit();
        })
    ;
}